import React from 'react';
import PropTypes from 'prop-types';
import OrderingSelect from 'four-nets/ui-v2/ordering-select/ordering-select';
import { FormattedMessage } from 'react-intl';
import { UserOrderingSelectFragment } from './user-ordering-select.graphql';
import { Site } from '../../../site';

export type Props = React.SelectHTMLAttributes<HTMLSelectElement> & {
    userOrdering: NonNullable<UserOrderingSelectFragment['userOrdering']>;
};

interface Context {
    site: Site;
}

class UserOrderingSelect extends React.PureComponent<Props> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };
    context!: Context;

    render() {
        const { userOrdering, ...rest } = this.props;

        return (
            <FormattedMessage id='ORDER_BY'>
                {msg => (
                    <OrderingSelect {...rest}>
                        {userOrdering.enumValues
                            ? userOrdering.enumValues.map(({ name, description }) => {
                                  if (!this.context.site.isWedding && name.indexOf('WEDDING') > -1) {
                                      return null;
                                  }
                                  return (
                                      <option key={name} value={name}>
                                          {msg}&nbsp;{description}
                                      </option>
                                  );
                              })
                            : null}
                    </OrderingSelect>
                )}
            </FormattedMessage>
        );
    }
}

export default UserOrderingSelect;
